import { Link } from 'react-router-dom';
import SlotImage from '@/components/base/SlotImage';

export default function CTASection() {
  return (
    <section className="relative py-20 md:py-28 overflow-hidden">
      <div className="absolute inset-0">
        <SlotImage
          slot="cta_image"
          fallback="https://storage.helloreaddy.io/project_files/e45ec48e-345c-4840-a547-bcc42428da39/66b0c0ea-15a5-4160-915f-b54a85c2a275_compressed_WhatsApp-Image-2026-09-12-at-15.29.02-2.webp"
          alt="Community gathering"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-primary-900/82" />
      </div>

      <div className="relative z-10 max-w-[900px] mx-auto px-4 md:px-8 text-center">
        <div className="inline-flex items-center gap-2 bg-accent-500/20 border border-accent-500/40 text-accent-300 text-xs font-label tracking-widest uppercase px-4 py-2 rounded-full mb-6">
          <i className="ri-heart-line" aria-hidden="true" />
          Join Our Community
        </div>
        <h2 className="font-heading text-3xl md:text-5xl font-bold text-white leading-tight mb-6">
          Join Us in Making a Difference
        </h2>
        <p className="text-white/70 text-lg leading-relaxed mb-8 max-w-2xl mx-auto">
          Discover how you can get involved and support our community initiatives today. Whether you want to volunteer, donate, or simply worship with us — there&apos;s a place for you at TGMCI.
        </p>
        <div className="flex flex-wrap items-center justify-center gap-4">
          <Link to="/contact" className="btn-accent px-8 py-4 text-sm">
            <i className="ri-user-add-line" aria-hidden="true" />
            Get Involved
          </Link>
          <Link to="/give" className="btn-outline-white px-8 py-4 text-sm">
            <i className="ri-heart-line" aria-hidden="true" />
            Support TGMCI
          </Link>
          <Link to="/services" className="btn-outline-white px-8 py-4 text-sm">
            <i className="ri-building-line" aria-hidden="true" />
            Our Services
          </Link>
        </div>
      </div>
    </section>
  );
}